export default __webpack_public_path__ + "static/smallBackground-59d6f781ec8b4576f8fdd54e7b97b396.svg";